module.exports = __webpack_public_path__ + "img/2.3e23d435.jpg";